var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.collapse ? _c('div', {
    staticClass: "sidebar"
  }, [_c('el-menu', {
    attrs: {
      "mode": "vertical",
      "default-active": "0",
      "background-color": "#304156",
      "text-color": "#bfcbd9",
      "active-text-color": "#409EFF"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Anima Admin")]), _vm._l(_vm.menuItems, function (item, itemIndex) {
    return _c(item.submenus ? 'el-submenu' : 'el-menu-item', {
      key: itemIndex,
      tag: "component",
      attrs: {
        "index": String(itemIndex)
      },
      scopedSlots: _vm._u([item.submenus ? {
        key: "title",
        fn: function () {
          return [item.icon ? _c('icon', {
            attrs: {
              "type": item.icon
            }
          }) : _vm._e(), _vm._v(" " + _vm._s(item.name) + " ")];
        },
        proxy: true
      } : null], null, true)
    }, [item.submenus ? _c('el-menu-item-group', _vm._l(item.submenus, function (submenu, submenuIndex) {
      return _c('el-menu-item', {
        key: submenuIndex,
        attrs: {
          "index": `${itemIndex}-${submenuIndex + 1}`
        },
        on: {
          "click": function ($event) {
            return _vm.handleSubmenuCLick(submenu.route);
          }
        }
      }, [_vm._v(" " + _vm._s(submenu.name) + " ")]);
    }), 1) : _vm._e(), !item.submenus ? _c('span', [item.icon ? _c('icon', {
      attrs: {
        "type": item.icon
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(item.name) + " ")], 1) : _vm._e()], 1);
  })], 2)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }